// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__udmrQ","formContainer":"Login_formContainer__KgxQ8","image":"Login_image__20NDj"};